export interface VideoEmbedPreview {
  title: string;
  channelName: string;
  channelUrl: string;
  description: string | null;
  thumbnailUrl: string;
}

interface OEmbedResponse {
  title: string;
  author_name: string;
  author_url: string;
  thumbnail_url: string;
  description?: string;
}

export function getChannelInitials(channelName: string, fallback: string): string {
  const initials = channelName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');

  return initials || fallback;
}

export async function fetchOEmbedPreview(endpoint: string): Promise<VideoEmbedPreview | null> {
  const response = await fetch(endpoint);

  if (!response.ok) {
    return null;
  }

  const payload = await response.json() as OEmbedResponse;

  return {
    title: payload.title,
    channelName: payload.author_name,
    channelUrl: payload.author_url,
    description: payload.description?.trim() || null,
    thumbnailUrl: payload.thumbnail_url,
  };
}
